import React, { memo } from "react";
import ReviewScreen from "./ReviewScreen";
import Button from "../Common/Button";
import { useDispatch } from "react-redux";
import { setReviewMode } from "../../store/fullLengthExam";
import ArrowDown from "../../constants/icons/DownArrow";

const ReviewModal = ({
  reviewModalOpen,
  closeReviewModal,
  currentSectionIndex,
  sectionQuestions,
  examData,
  markedQuestions,
  userAnswers,
  currentQuestionIndex,
  reviewMode,
}) => {
  const dispatch = useDispatch();
  if (!reviewModalOpen) return null;
  return (
    <div
      style={{
        position: "fixed",
        // top: "calc(100vh - 495px)",
        bottom: "6.3%",
        left: "50%",
        right: "50%",
        zIndex: 1050,
        display: "grid",
        justifyContent: "center",
        alignItems: "center",
      }}
      onClick={closeReviewModal}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "relative",
          zIndex: 1051,
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "0 0 15px rgba(0, 0, 0, 0.2)",
          padding: "20px",
          marginBottom: "-12px",
        }}
      >
        <ReviewScreen
          currentSectionIndex={currentSectionIndex}
          sectionQuestions={sectionQuestions}
          examData={examData}
          markedQuestions={markedQuestions}
          userAnswers={userAnswers}
          currentQuestionIndex={currentQuestionIndex}
          reviewMode={reviewMode}
          isInModal
        />
        <div className="d-flex justify-content-center">
          <Button
            onClick={() => {
              closeReviewModal();
              dispatch(setReviewMode(true));
            }}
            style={{
              backgroundColor: "transparent",
              border: "1px blue solid",
              borderRadius: "25px",
              color: "blue",
              width: "250px",
            }}
            className="mt-3"
          >
            Go to Review Page
          </Button>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ArrowDown style={{ zIndex: 1060 }} color="white" size={40} />
      </div>
    </div>
  );
};

export default memo(ReviewModal);
